import { Modal, ModalProps } from 'antd';

import LabelManagement from '.';

interface Props extends ModalProps {
  defaultMenu?: string;
}

const LabelManagementModal: React.FC<Props> = ({ ...props }) => {
  return (
    <Modal
      title={null}
      footer={null}
      {...props}
      centered
      width={'95vw'}
      style={{
        height: '95vh',
      }}
    >
      <LabelManagement showSidebar={false} defaultMenu={props.defaultMenu} />
    </Modal>
  );
};

export default LabelManagementModal;
